<template>

	<div class="payment modal">

		<div class="modal-wrap">

			<div :class="{'modal-inner':true,iframe:!!iframe}">

				<h2 :class="{'modal-title':true, 'has-trial-text': trial&&trialTextProcessed!==''}"><span class="text-wrap" :title="showTitle">{{ showTitle }}</span><span class="close" @click="close" v-if="!isIntent">X</span></h2>

				<h3 v-html="trialTextProcessed" v-if="trial&&trialTextProcessed!==''" class="trial-text" />

				<div class="modal-inner-scroll">

					<form class="form" @submit.prevent="submit">

						<p class="opening-text" v-if="openingTextProcessed" v-html="openingTextProcessed" />

						<div class="iframe-wrap-3d" v-if="iframe"><iframe :src="iframe"></iframe></div>

						<div class="address-input-wrap" v-if="(!isIntent||retryIntent)&&paymentMethodsDropdown.length>0">
							<v-select 
								v-model="paymentMethod" 
								:options="paymentMethodsDropdown" 
								:reduce="option => option._id"
								:append-to-body="true"
								:disabled="processing" 
								placeholder="Current or new payment method?"
							/>
						</div>

						<div class="address-inputs" v-if="showAddressOptions">

							<p v-if="needsPostcode">Your ZIP/Postal Code is the only part of your address that is mandatory but please enter your full address for invoices.</p>

							<p v-if="!needsPostcode">Please enter your full address for invoices (this isn't mandatory).</p>

							<div
								v-for="(addrField, addrFieldIndex) in [{f:'line1',p:'Address Line 1',r:false},{f:'line2',p:'Address Line 2',r:false},{f:'city',p:'City',r:false},{f:'state',p:'State/County',r:false},{f:'postal_code',p:'ZIP/Postal Code',r:true}]" 
					            :key="'t'+addrFieldIndex" 
					            class="address-input-wrap"
							>
								<FormInput 
									type="text" 
									:noMarginBottom="true" 
									v-model="address[addrField.f]" 
									:name="addrField.f" 
									:placeholder="addrField.p" 
									:required="addrField.r"
									classes="font-weight-400"
								/>
							</div>
							<div class="address-input-wrap">
								<v-select 
						            v-model="address.country" 
						            :options="countries" 
						            :reduce="option => option._id"
						            :append-to-body="true"
						            placeholder="Country"
						        />
						    </div>

					    </div>

						<div class="coupon" v-if="type==='pay'&&!isIntent">
							<p v-if="!hasCoupon" @click="hasACoupon">Have a coupon? Add here before your card number.</p>
							<FormInput 
								type="text" 
								:noMarginBottom="true" 
								v-model="coupon" 
								placeholder="Enter your coupon code" 
								classes="font-weight-400"
								theRef="coupon-input"
								v-if="hasCoupon"
							/>
							<input v-if="hasCoupon" type="button" class="coupon-btn" value="Apply" @click="checkCoupon">
						</div>

						<div id="card-element" v-html="'Loading...'" :class="{hide:!showPaymentCartInput}" />

						<div class="pay-wrap" v-if="!isIntent||retryIntent">

							<input type="submit" :class="{'pay-btn':true,disabled:!canPay}" :value="submitButton">

							<p v-if="errorMsg != ''" :class="{ message: true, error: errors !== '' }" v-html="errorMsg" />

						</div>

					</form>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import FormInput from './Form/Input.vue'
export default {
	name: 'Payment',
	components: {FormInput},
	props: {
		title: String,
		frequency: String,
		paymentInfo: Object,
		amount: Number,
		type: {
			type: String,
			default: 'pay' // pay, new, update, actionRequired
		},
		service: {
			type: String,
			default: 'keywords' // keywords, analysis_credits
		},
		trial: {
			type: Boolean,
			default: false
		},
		trialText: {
			type: String,
			default: ''
		},
		requireAddress: {
			type: Boolean,
			default: false
		},
		stripeTextColour: {
			type: String,
			default: '#000000'
		},
		stripeBGColour: {
			type: String,
			default: ''
		},
		openingText: {
			type: String
		},
		usePaymentMethods: {
			type: Boolean,
			default: true
		},
		setPaymentMethod: {
			type: String,
			default: null
		},
		intent: { // if this is passed it is for subscription updates that require authorisation
			type: Object
		},
		retryIntent: {
			type: Boolean,
			default: false
		}
	},
	data() {

		return {
			address: {
				line1: '',
				line2: '',
				city: '',
				state: '',
				postal_code: ''
			},
			iframe: null,
			processing: false,
			errors: '',
			otherMessage: '',
			stripe: null,
			customerName: '',
			customerEmail: '',
			cardElement: null,
			coupon: "",
			couponOk: false,
			hasCoupon: false,
			couponInfo: {},
			newPrice: '',
			fetchedSettings: false,
			stripeLive: false,
			currency: '$',
			paymentMethod: null,
			paymentMethods: [],
			countries: [ 
				{label: 'Afghanistan', _id: 'AF'}, 
				{label: 'Åland Islands', _id: 'AX'}, 
				{label: 'Albania', _id: 'AL'}, 
				{label: 'Algeria', _id: 'DZ'}, 
				{label: 'American Samoa', _id: 'AS'}, 
				{label: 'AndorrA', _id: 'AD'}, 
				{label: 'Angola', _id: 'AO'}, 
				{label: 'Anguilla', _id: 'AI'}, 
				{label: 'Antarctica', _id: 'AQ'}, 
				{label: 'Antigua and Barbuda', _id: 'AG'}, 
				{label: 'Argentina', _id: 'AR'}, 
				{label: 'Armenia', _id: 'AM'}, 
				{label: 'Aruba', _id: 'AW'}, 
				{label: 'Australia', _id: 'AU'}, 
				{label: 'Austria', _id: 'AT'}, 
				{label: 'Azerbaijan', _id: 'AZ'}, 
				{label: 'Bahamas', _id: 'BS'}, 
				{label: 'Bahrain', _id: 'BH'}, 
				{label: 'Bangladesh', _id: 'BD'}, 
				{label: 'Barbados', _id: 'BB'}, 
				{label: 'Belarus', _id: 'BY'}, 
				{label: 'Belgium', _id: 'BE'}, 
				{label: 'Belize', _id: 'BZ'}, 
				{label: 'Benin', _id: 'BJ'}, 
				{label: 'Bermuda', _id: 'BM'}, 
				{label: 'Bhutan', _id: 'BT'}, 
				{label: 'Bolivia', _id: 'BO'}, 
				{label: 'Bosnia and Herzegovina', _id: 'BA'}, 
				{label: 'Botswana', _id: 'BW'}, 
				{label: 'Bouvet Island', _id: 'BV'}, 
				{label: 'Brazil', _id: 'BR'}, 
				{label: 'British Indian Ocean Territory', _id: 'IO'}, 
				{label: 'Brunei Darussalam', _id: 'BN'}, 
				{label: 'Bulgaria', _id: 'BG'}, 
				{label: 'Burkina Faso', _id: 'BF'}, 
				{label: 'Burundi', _id: 'BI'}, 
				{label: 'Cambodia', _id: 'KH'}, 
				{label: 'Cameroon', _id: 'CM'}, 
				{label: 'Canada', _id: 'CA'}, 
				{label: 'Cape Verde', _id: 'CV'}, 
				{label: 'Cayman Islands', _id: 'KY'}, 
				{label: 'Central African Republic', _id: 'CF'}, 
				{label: 'Chad', _id: 'TD'}, 
				{label: 'Chile', _id: 'CL'}, 
				{label: 'China', _id: 'CN'}, 
				{label: 'Christmas Island', _id: 'CX'}, 
				{label: 'Cocos (Keeling) Islands', _id: 'CC'}, 
				{label: 'Colombia', _id: 'CO'}, 
				{label: 'Comoros', _id: 'KM'}, 
				{label: 'Congo', _id: 'CG'}, 
				{label: 'Congo, The Democratic Republic of the', _id: 'CD'}, 
				{label: 'Cook Islands', _id: 'CK'}, 
				{label: 'Costa Rica', _id: 'CR'}, 
				{label: 'Cote D\'Ivoire', _id: 'CI'}, 
				{label: 'Croatia', _id: 'HR'}, 
				{label: 'Cuba', _id: 'CU'}, 
				{label: 'Cyprus', _id: 'CY'}, 
				{label: 'Czech Republic', _id: 'CZ'}, 
				{label: 'Denmark', _id: 'DK'}, 
				{label: 'Djibouti', _id: 'DJ'}, 
				{label: 'Dominica', _id: 'DM'}, 
				{label: 'Dominican Republic', _id: 'DO'}, 
				{label: 'Ecuador', _id: 'EC'}, 
				{label: 'Egypt', _id: 'EG'}, 
				{label: 'El Salvador', _id: 'SV'}, 
				{label: 'Equatorial Guinea', _id: 'GQ'}, 
				{label: 'Eritrea', _id: 'ER'}, 
				{label: 'Estonia', _id: 'EE'}, 
				{label: 'Ethiopia', _id: 'ET'}, 
				{label: 'Falkland Islands (Malvinas)', _id: 'FK'}, 
				{label: 'Faroe Islands', _id: 'FO'}, 
				{label: 'Fiji', _id: 'FJ'}, 
				{label: 'Finland', _id: 'FI'}, 
				{label: 'France', _id: 'FR'}, 
				{label: 'French Guiana', _id: 'GF'}, 
				{label: 'French Polynesia', _id: 'PF'}, 
				{label: 'French Southern Territories', _id: 'TF'}, 
				{label: 'Gabon', _id: 'GA'}, 
				{label: 'Gambia', _id: 'GM'}, 
				{label: 'Georgia', _id: 'GE'}, 
				{label: 'Germany', _id: 'DE'}, 
				{label: 'Ghana', _id: 'GH'}, 
				{label: 'Gibraltar', _id: 'GI'}, 
				{label: 'Greece', _id: 'GR'}, 
				{label: 'Greenland', _id: 'GL'}, 
				{label: 'Grenada', _id: 'GD'}, 
				{label: 'Guadeloupe', _id: 'GP'}, 
				{label: 'Guam', _id: 'GU'}, 
				{label: 'Guatemala', _id: 'GT'}, 
				{label: 'Guernsey', _id: 'GG'}, 
				{label: 'Guinea', _id: 'GN'}, 
				{label: 'Guinea-Bissau', _id: 'GW'}, 
				{label: 'Guyana', _id: 'GY'}, 
				{label: 'Haiti', _id: 'HT'}, 
				{label: 'Heard Island and Mcdonald Islands', _id: 'HM'}, 
				{label: 'Holy See (Vatican City State)', _id: 'VA'}, 
				{label: 'Honduras', _id: 'HN'}, 
				{label: 'Hong Kong', _id: 'HK'}, 
				{label: 'Hungary', _id: 'HU'}, 
				{label: 'Iceland', _id: 'IS'}, 
				{label: 'India', _id: 'IN'}, 
				{label: 'Indonesia', _id: 'ID'}, 
				{label: 'Iran, Islamic Republic Of', _id: 'IR'}, 
				{label: 'Iraq', _id: 'IQ'}, 
				{label: 'Ireland', _id: 'IE'}, 
				{label: 'Isle of Man', _id: 'IM'}, 
				{label: 'Israel', _id: 'IL'}, 
				{label: 'Italy', _id: 'IT'}, 
				{label: 'Jamaica', _id: 'JM'}, 
				{label: 'Japan', _id: 'JP'}, 
				{label: 'Jersey', _id: 'JE'}, 
				{label: 'Jordan', _id: 'JO'}, 
				{label: 'Kazakhstan', _id: 'KZ'}, 
				{label: 'Kenya', _id: 'KE'}, 
				{label: 'Kiribati', _id: 'KI'}, 
				{label: 'Korea, Democratic People\'S Republic of', _id: 'KP'}, 
				{label: 'Korea, Republic of', _id: 'KR'}, 
				{label: 'Kuwait', _id: 'KW'}, 
				{label: 'Kyrgyzstan', _id: 'KG'}, 
				{label: 'Lao People\'S Democratic Republic', _id: 'LA'}, 
				{label: 'Latvia', _id: 'LV'}, 
				{label: 'Lebanon', _id: 'LB'}, 
				{label: 'Lesotho', _id: 'LS'}, 
				{label: 'Liberia', _id: 'LR'}, 
				{label: 'Libyan Arab Jamahiriya', _id: 'LY'}, 
				{label: 'Liechtenstein', _id: 'LI'}, 
				{label: 'Lithuania', _id: 'LT'}, 
				{label: 'Luxembourg', _id: 'LU'}, 
				{label: 'Macao', _id: 'MO'}, 
				{label: 'Macedonia, The Former Yugoslav Republic of', _id: 'MK'}, 
				{label: 'Madagascar', _id: 'MG'}, 
				{label: 'Malawi', _id: 'MW'}, 
				{label: 'Malaysia', _id: 'MY'}, 
				{label: 'Maldives', _id: 'MV'}, 
				{label: 'Mali', _id: 'ML'}, 
				{label: 'Malta', _id: 'MT'}, 
				{label: 'Marshall Islands', _id: 'MH'}, 
				{label: 'Martinique', _id: 'MQ'}, 
				{label: 'Mauritania', _id: 'MR'}, 
				{label: 'Mauritius', _id: 'MU'}, 
				{label: 'Mayotte', _id: 'YT'}, 
				{label: 'Mexico', _id: 'MX'}, 
				{label: 'Micronesia, Federated States of', _id: 'FM'}, 
				{label: 'Moldova, Republic of', _id: 'MD'}, 
				{label: 'Monaco', _id: 'MC'}, 
				{label: 'Mongolia', _id: 'MN'}, 
				{label: 'Montserrat', _id: 'MS'}, 
				{label: 'Morocco', _id: 'MA'}, 
				{label: 'Mozambique', _id: 'MZ'}, 
				{label: 'Myanmar', _id: 'MM'}, 
				{label: 'Namibia', _id: 'NA'}, 
				{label: 'Nauru', _id: 'NR'}, 
				{label: 'Nepal', _id: 'NP'}, 
				{label: 'Netherlands', _id: 'NL'}, 
				{label: 'Netherlands Antilles', _id: 'AN'}, 
				{label: 'New Caledonia', _id: 'NC'}, 
				{label: 'New Zealand', _id: 'NZ'}, 
				{label: 'Nicaragua', _id: 'NI'}, 
				{label: 'Niger', _id: 'NE'}, 
				{label: 'Nigeria', _id: 'NG'}, 
				{label: 'Niue', _id: 'NU'}, 
				{label: 'Norfolk Island', _id: 'NF'}, 
				{label: 'Northern Mariana Islands', _id: 'MP'}, 
				{label: 'Norway', _id: 'NO'}, 
				{label: 'Oman', _id: 'OM'}, 
				{label: 'Pakistan', _id: 'PK'}, 
				{label: 'Palau', _id: 'PW'}, 
				{label: 'Palestinian Territory, Occupied', _id: 'PS'}, 
				{label: 'Panama', _id: 'PA'}, 
				{label: 'Papua New Guinea', _id: 'PG'}, 
				{label: 'Paraguay', _id: 'PY'}, 
				{label: 'Peru', _id: 'PE'}, 
				{label: 'Philippines', _id: 'PH'}, 
				{label: 'Pitcairn', _id: 'PN'}, 
				{label: 'Poland', _id: 'PL'}, 
				{label: 'Portugal', _id: 'PT'}, 
				{label: 'Puerto Rico', _id: 'PR'}, 
				{label: 'Qatar', _id: 'QA'}, 
				{label: 'Reunion', _id: 'RE'}, 
				{label: 'Romania', _id: 'RO'}, 
				{label: 'Russian Federation', _id: 'RU'}, 
				{label: 'RWANDA', _id: 'RW'}, 
				{label: 'Saint Helena', _id: 'SH'}, 
				{label: 'Saint Kitts and Nevis', _id: 'KN'}, 
				{label: 'Saint Lucia', _id: 'LC'}, 
				{label: 'Saint Pierre and Miquelon', _id: 'PM'}, 
				{label: 'Saint Vincent and the Grenadines', _id: 'VC'}, 
				{label: 'Samoa', _id: 'WS'}, 
				{label: 'San Marino', _id: 'SM'}, 
				{label: 'Sao Tome and Principe', _id: 'ST'}, 
				{label: 'Saudi Arabia', _id: 'SA'}, 
				{label: 'Senegal', _id: 'SN'}, 
				{label: 'Serbia and Montenegro', _id: 'CS'}, 
				{label: 'Seychelles', _id: 'SC'}, 
				{label: 'Sierra Leone', _id: 'SL'}, 
				{label: 'Singapore', _id: 'SG'}, 
				{label: 'Slovakia', _id: 'SK'}, 
				{label: 'Slovenia', _id: 'SI'}, 
				{label: 'Solomon Islands', _id: 'SB'}, 
				{label: 'Somalia', _id: 'SO'}, 
				{label: 'South Africa', _id: 'ZA'}, 
				{label: 'South Georgia and the South Sandwich Islands', _id: 'GS'}, 
				{label: 'Spain', _id: 'ES'}, 
				{label: 'Sri Lanka', _id: 'LK'}, 
				{label: 'Sudan', _id: 'SD'}, 
				{label: 'Surilabel', _id: 'SR'}, 
				{label: 'Svalbard and Jan Mayen', _id: 'SJ'}, 
				{label: 'Swaziland', _id: 'SZ'}, 
				{label: 'Sweden', _id: 'SE'}, 
				{label: 'Switzerland', _id: 'CH'}, 
				{label: 'Syrian Arab Republic', _id: 'SY'}, 
				{label: 'Taiwan, Province of China', _id: 'TW'}, 
				{label: 'Tajikistan', _id: 'TJ'}, 
				{label: 'Tanzania, United Republic of', _id: 'TZ'}, 
				{label: 'Thailand', _id: 'TH'}, 
				{label: 'Timor-Leste', _id: 'TL'}, 
				{label: 'Togo', _id: 'TG'}, 
				{label: 'Tokelau', _id: 'TK'}, 
				{label: 'Tonga', _id: 'TO'}, 
				{label: 'Trinidad and Tobago', _id: 'TT'}, 
				{label: 'Tunisia', _id: 'TN'}, 
				{label: 'Turkey', _id: 'TR'}, 
				{label: 'Turkmenistan', _id: 'TM'}, 
				{label: 'Turks and Caicos Islands', _id: 'TC'}, 
				{label: 'Tuvalu', _id: 'TV'}, 
				{label: 'Uganda', _id: 'UG'}, 
				{label: 'Ukraine', _id: 'UA'}, 
				{label: 'United Arab Emirates', _id: 'AE'}, 
				{label: 'United Kingdom', _id: 'GB'}, 
				{label: 'United States', _id: 'US'}, 
				{label: 'United States Minor Outlying Islands', _id: 'UM'}, 
				{label: 'Uruguay', _id: 'UY'}, 
				{label: 'Uzbekistan', _id: 'UZ'}, 
				{label: 'Vanuatu', _id: 'VU'}, 
				{label: 'Venezuela', _id: 'VE'}, 
				{label: 'Viet Nam', _id: 'VN'}, 
				{label: 'Virgin Islands, British', _id: 'VG'}, 
				{label: 'Virgin Islands, U.S.', _id: 'VI'}, 
				{label: 'Wallis and Futuna', _id: 'WF'}, 
				{label: 'Western Sahara', _id: 'EH'}, 
				{label: 'Yemen', _id: 'YE'}, 
				{label: 'Zambia', _id: 'ZM'}, 
				{label: 'Zimbabwe', _id: 'ZW'} 
			]
		}

	},
	computed: { 

		isIntent () {

			return this.intent && Object.keys( this.intent ).length > 0;

		},

		openingTextProcessed () {

			if ( this.isIntent ) {

				if ( this.retryIntent ) return "Please select/add a payment method to retry your payment (this will become the payment method used for any future payments for this subscription).";

				return "We are connecting to your bank...";

			} else {

				return this.openingText;

			}

		},

		canPay () {

			if ( this.processing ) return false;

			return ( this.paymentMethodsDropdown.length === 0 || !!this.paymentMethod );

		},

		showAddressOptions () {

			return ( ( !this.isIntent || this.retryIntent ) && this.requireAddress && ( this.paymentMethodsDropdown.length === 0 || this.paymentMethod === 'new' || this.type === 'new' ) );

		},

		showPaymentCartInput () {

			return ( ( !this.isIntent || this.retryIntent ) && ( this.paymentMethodsDropdown.length === 0 || this.paymentMethod === 'new' ) );

		},

		paymentMethodsDropdown () {

			if ( !this.usePaymentMethods || this.paymentMethods.length === 0 || this.type === 'new' ) return [];

			let r = this.paymentMethods.map( method => {

				return {
					label: method.label, 
					_id: method._id
				};

			});

			r.push({ label: 'New Card', _id: 'new' });

			return r;

		},

		trialTextProcessed () {

			if ( this.trialText !== '' ) {

				if ( this.hasCoupon && Object.keys(this.couponInfo).length > 0 && this.couponInfo.amountOffType !== 'trial' ) {

					return "The trial isn't available when using a coupon.";

				}

				return this.trialText;

			}

			return '';

		},

		trialCheck () {

			if ( this.hasCoupon && this.couponInfo.amountOffType !== 'trial' ) return false;

			return this.trial;

		},

		submitButton () {

			if ( this.processing ) return 'Processing...';

			if ( this.retryIntent ) return 'Retry Payment';

			if ( this.type === 'update' ) return 'Update';

			if ( this.type === 'new' ) return 'Add';

			if ( this.trialCheck ) return 'Continue Trial';

			return 'Pay';

		},
		
		showTitle () {

			if ( this.isIntent ) {

				return "Payment";

			}

			if ( this.type === 'update' ) return 'Update Your Payment Method';

			if ( this.type === 'new' ) return 'Add A New Payment Method';

			let t = this.title ? this.title : 'Payment';

			let x, f = this.frequency !== 'one_time' ? this.frequency : '';

			if ( this.newPrice ) x = this.numberWithCommas(this.newPrice) + ( ( !this.couponOk && f  ) ? ' per ' + f : '' );

			if ( x ) t += ' - ' + x;

			return t;

		},

		errorMsg () {

			if ( this.errors ) return this.errors;
			if ( this.otherMessage ) return this.otherMessage;
			return '';

		},

		needsPostcode () {

			if ( !this.address.country ) return true;

			// https://hellowahab.wordpress.com/2011/05/24/list-of-countries-without-postal-codes/

			return ['AO', 'AG', 'BZ', 'BJ', 'BW', 'BF', 'BI','CM', 'CF', 'KM', 'CK', 'DJ', 'DM', 'GQ', 'ER', 'FJ', 'GH', 'GD', 'GN', 'GY', 'IE', 'JM', 'KE', 'KI', 'MW', 'ML', 'MR', 'MU','NR', 'NU', 'PA', 'QA', 'RW', 'KN', 'LC','ST', 'SA', 'SC', 'SL', 'SB', 'SO', 'ZA','SR', 'TZ', 'TK', 'TO', 'TT', 'TV', 'UG','AE', 'VU', 'YE', 'ZW'].indexOf( this.address.country ) < 0;

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		hasACoupon () {

			this.hasCoupon = true;
			setTimeout( function() { this.$refs['coupon-input'].select(); }.bind(this), 10 );

		},

		displayError(error,ok) {

			this.errors = '';

			if ( ok ) this.otherMessage = error ? error.message : '';
			else this.errors = error ? error.message : '';

		},

		submit() {

			var _this = this;
console.log('this.paymentMethodsDropdown.length',this.paymentMethodsDropdown.length);
			if ( this.paymentMethodsDropdown.length > 0 ) {

				if ( !this.paymentMethod ) return;

				if ( this.paymentMethod !== 'new' ) {

					if ( this.service === 'keywords' ) {

						const p = this.paymentMethods.find( method => method._id === this.paymentMethod );

						this.stripePaymentMethodHandler( p );

					}
					else {

						this.updateLoadingText(true);
						this.processing = true;

						let info = {
							amount: this.amount * 100, 
							paymentMethodId: this.paymentMethod, 
							priceId: this.paymentInfo.price 
						};

						if ( typeof this.couponInfo.stripeId !== 'undefined' && this.couponOk ) {

							info.coupon = this.couponInfo.stripeId;

						}

						ApiService.post( 'payment-intent', info )
							.then( function( response ) {

								let r = response.data;

								if ( r.client_secret ) {

									_this.stripe.confirmCardPayment( r.client_secret )
									.then((result) => {

										this.updateLoadingText();

										if (result.error) {
											
											_this.displayError(['invalid_request_error'].indexOf(result.error.type)>=0?{message:'Your card was declined'}:result.error);
											this.processing = false;

										} else {

											this.$emit( 'close-payment', { success: true, price: this.paymentInfo.price } );

										}

									}).catch((err) => {

										console.error('Error confirming card payment:', err);

										this.updateLoadingText();

									});

								}
								else if ( r.status === 'succeeded' ) {

									this.updateLoadingText();

									this.$emit( 'close-payment', { success: true, price: this.paymentInfo.price } );

								}
								else {

									_this.displayError("We are having trouble processing your payment. Please try again later.");

									this.updateLoadingText();

								}

							}.bind(this))
							.catch( function(error) {

								this.displayError( { message: error.response.data.error } );

								this.updateLoadingText();

								this.processing = false;

							}.bind(this));

					}

					return;

				}

			}

			if ( _this.requireAddress && _this.address.postal_code === '' && this.needsPostcode ) {

				_this.displayError( { message: 'Please enter a valid ZIP/Postal Code.' } );

				return;

			}

			this.updateLoadingText(true);

			let billing_details = {
				name: _this.customerName,
				email: _this.customerEmail
			};

			if ( _this.requireAddress ) billing_details.address = _this.address;

			this.processing = true;
			console.log('here 1');

			_this.stripe.createPaymentMethod({
				type: 'card',
				card: _this.cardElement,
				// Reference: https://stripe.com/docs/api/payment_methods/create#create_payment_method-billing_details
				billing_details: billing_details,
			}).then((result) => {
				_this.displayError('');
				_this.updateLoadingText();
				console.log('here 2');
				if (result.error) {
					_this.displayError(result.error);
					console.error('Error creating Stripe Payment Method: ', result.error);
					this.processing = false;
				} else {
					// Proceed to next step of creating customer and subscription/invoice 
					_this.stripePaymentMethodHandler(result.paymentMethod);
				}
			});

		},

		stripePaymentMethodHandler( paymentMethod ) {
			
			this.updateLoadingText('Processing...');
			this.processing = true;

			let info = { 
					name: this.customerName, 
					email: this.customerEmail, 
					paymentMethodId: paymentMethod.id, 
					action: this.type, 
					trial: this.trialCheck,
					address: this.address
				}, 
				method = 'payment',
				restType = 'post';

			if ( this.requireAddress ) info.address = this.address;

			if ( this.retryIntent ) {

				method = '/payment-intent';
				restType = 'put';
				info = {
					payment_method: paymentMethod.id, 
					paymentIntentId: this.intent.id
				}

			}
			else if ( this.type !== 'pay' ) {

				method += '/methods';

			}
			else {

				info.price = this.paymentInfo.price;
				info.product = this.paymentInfo.product;

				if ( typeof this.couponInfo.stripeId !== 'undefined' && this.couponOk ) {

					info.coupon = this.couponInfo.stripeId;

				}

			}
			
			ApiService[restType]( method, info )
            .then( function( response ) {

				this.updateLoadingText();

				if ( this.type !== 'pay' ) {

            		this.$emit( 'close-payment', { success: true, message: response.data } );

            	}
            	else {

              		this.manageSubscriptionStatus( response.data );

	            }

            }.bind(this))
            .catch( function(error) {

				this.displayError( { message: error.response.data.error } );

				this.processing = false;

				this.updateLoadingText();

            }.bind(this));

		},

		checkCoupon() {

			if ( this.coupon === '' ) return;

			this.updateLoadingText('Checking coupon...');

			ApiService.get( 'payment/coupon/check/' + this.coupon + '/' + this.paymentInfo.product + '/' + this.amount + '/' + this.frequency )
            .then( function( response ) {
              
              	this.couponInfo = response.data;

              	this.displayError({ message: this.couponInfo.congrats },true);

              	this.newPrice = this.couponInfo.newPrice || '';
            	
            	this.updateLoadingText();

            	this.couponOk = true;

            	this.setUpStripe ();

            }.bind(this))
            .catch( function(error) {

				this.displayError({ message: error.response.data.error });

				this.updateLoadingText();

				this.couponOk = false;

            }.bind(this));

		},

		setUpStripe (init) {

			if ( init && this.isIntent && !this.retryIntent ) {

				this.manageSubscriptionStatus();
				return;

			}

			if ( this.type === 'pay' && init ) this.newPrice = this.currency + this.amount.toFixed(2);

			let _this = this,
				elements = this.stripe.elements({
					fonts: [ { cssSrc: 'https://fonts.googleapis.com/css?family=Roboto|Lato:400,700' } ]
				}),
				elementsStyles = {
					base: {
						color: _this.stripeTextColour,
						iconColor: _this.stripeTextColour,
						fontFamily: "'Roboto', Arial, Tahoma, Geneva, sans-serif",
						fontWeight: "400",
						fontSmoothing: "antialiased",
						fontSize: "16px",
						"::placeholder": {
							color: "#777777"
						}
					},
					invalid: {
						color: "#d20000",
						iconColor: "#d20000"
					}
				};

			_this.cardElement = elements.create("card", { hidePostalCode: true, style: elementsStyles })

			_this.cardElement.mount("#card-element");

			_this.cardElement.addEventListener('change', ({error}) => {
				_this.displayError(error);
			});
			
		},
		manageSubscriptionStatus( info ) {

			let _this = this, 
				intent;

			if ( !this.isIntent ) {

				switch ( _this.service ) {

					case 'keywords' :

						const { latest_invoice } = info;
						intent = latest_invoice.payment_intent;

					break;

					case 'analysis_credits' :

						intent = info;

					break;

				}

			}
			else {

				if ( this.retryIntent ) {

					intent = info;

				}
				else {

					intent = this.intent;

				}

			}
			 
			if (intent) {
				/* Do NOT share or embed your client_secret anywhere */
				const { client_secret, status } = intent,
				price = ( this.paymentInfo && this.paymentInfo.price ) ? this.paymentInfo.price : null;

				if ( status === "requires_action" || status === "requires_payment_method" || status === "requires_confirmation" || _this.service === 'analysis_credits' ) {

					if ( intent.action_url ) {

						this.iframe = intent.action_url;

						let events = [
							{ eventType: 'setup_intent.succeeded' },
							{ eventType: 'setup_intent.setup_failed' }
						];

						this.lastWebhookUpdateCheckCount = 300;

						general.registerForUpdates( ApiService, this, events, 
						function (callback) { // init function 

							callback(false); // let's go

						}.bind(this), 
						function (userInfo) { // Continue function
							
							
							
						}.bind(this),
						function (userInfo) { // Failed function
							
							this.$emit( 'close-payment', { success: false } );

						}.bind(this), 
						function (userInfo,webhookInfo) { // Complete function

							let rtn = { success: true, userInfo: userInfo };

							if ( webhookInfo && webhookInfo.eventType === 'setup_intent-setup_failed' ) {

								rtn.paymentCloseEvents = [{ eventType: 'customer.subscription.updated' }];

							}
							
							this.$emit( 'close-payment', rtn );

						}.bind(this));

					}
					else {

						if ( client_secret.split('_')[0] === 'seti' ) {

							_this.stripe.confirmCardSetup(client_secret)
							.then((result) => {

								if (result.error) {

									this.$emit( 'close-payment', { success: false, price: price, paymentCloseEvents:  [
											//{ eventType: 'payment_intent.succeeded', callback: 'paymentSucceeded' },
											{ eventType: 'setup_intent.setup_failed', callback: 'paymentFailed' }
										]
									});


								} else {

									this.$emit( 'close-payment', { success: true, price: price, paymentCloseEvents:  [
											{ eventType: 'setup_intent.succeeded', callback: 'setupIntentSucceeded' },
											//{ eventType: 'payment_intent.succeeded', callback: 'paymentSucceeded' },
											{ eventType: 'setup_intent.setup_failed', callback: 'paymentFailed' }
										]
									});

								}

							}).catch((err) => {

								this.$emit( 'close-payment', { success: false, price: price, paymentCloseEvents:  [
										{ eventType: 'payment_intent.succeeded', callback: 'paymentSucceeded' },
										{ eventType: 'setup_intent.setup_failed', callback: 'paymentFailed' },
										{ eventType: 'invoice.payment_failed', callback: 'paymentFailed' }
									]
								});

							}); 

						}
						else {

							_this.stripe.confirmCardPayment(client_secret)
							.then((result) => {

								if (result.error) {

									this.$emit( 'close-payment', { success: false, price: price, paymentCloseEvents:  [
											{ eventType: 'payment_intent.payment_failed', callback: 'paymentFailed' }
										]
									});


								} else {

									this.$emit( 'close-payment', { success: true, price: price, paymentCloseEvents:  [
											{ eventType: 'invoice.paid', callback: 'paymentSucceeded' },
											{ eventType: 'invoice.payment_succeeded', callback: 'paymentSucceeded' },
											{ eventType: 'payment_intent.payment_failed', callback: 'paymentFailed' }
										]
									});

								}

							}).catch((err) => {

								this.$emit( 'close-payment', { success: false, price: price, paymentCloseEvents:  [
										{ eventType: 'payment_intent.succeeded', callback: 'paymentSucceeded' },
										{ eventType: 'payment_intent.payment_failed', callback: 'paymentFailed' },
										{ eventType: 'invoice.payment_failed', callback: 'paymentFailed' }
									]
								});

							});

						}

					}

				} else {

					this.$emit( 'close-payment', { success: true, price: price } );

				}

			} else {

				if ( _this.service === 'analysis_credits' ) {

					_this.displayError({message:'There was an error processing your card'});
					this.processing = false;

				}
				else {

					/* If no payment intent exists, show the success state
					* Usually in this case if you set up a trial with the subscription
					*/
					this.$emit( 'close-payment', { success: true, price: this.paymentInfo.price } );

				}
			}
		},

		numberWithCommas(x) {

			x = x.toString().split('.');

			if ( x[1] && x[1] === '00' ) x.pop();

			return x.join('.').replace(/\B(?=(\d{3})+(?!\d))/g, ",");

		},

		close() {

			this.$emit('close-payment',{success:false,closeOnly:true});

		}
	},
	mounted() {
		
		this.updateLoadingText('One moment...');

		ApiService.get( 'stripe/settings' )
		.then( function( info ) {

			Vue.set( this, 'stripe', Stripe( info.data.key ) );

			Vue.set( this, 'stripeLive', info.data.live );

			Vue.set( this, 'currency', info.data.currency );

			this.fetchedSettings = true;

			this.updateLoadingText();

			this.setUpStripe(true);

		}.bind(this))
		.catch( function(err) {
			console.log(err);
		});

		ApiService.get( 'users', null, 'Payment' )
        .then( function( response ) {

        	this.customerName = response.data.firstName + ' ' + response.data.lastName;
        	this.customerEmail = response.data.email;
        	if ( response.data.address ) this.address = response.data.address;

			this.paymentMethods = response.data.paymentMethods;

			if ( this.setPaymentMethod ) {

				let p = this.paymentMethods.find( p => p.id === this.setPaymentMethod );

				if ( p ) {
				
					this.paymentMethod = p._id;

				}

			}

        }.bind(this))
        .catch( function(error) {

			this.displayError({ message: error.response.data.error });

			this.updateLoadingText();

        }.bind(this));

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.modal {

	.iframe-wrap-3d {

		position: fixed;
		z-index: 9999;
		width: 100%;
		height: 100%;
		left: 0;
    	top: 0;
		min-height:  96vh;
		background: rgba(40, 40, 40, 0.75) !important;

		iframe {
			width: 100%;
			height: 100%;
			max-height: 96vh;
			border: 0;
			max-width: 400px;
			margin: 2vh auto;
			display: block;
			border-radius: 4px;
		}

	}

	.modal-wrap {

		padding: 20px;

	}

	#card-element {

		background-color:@highlightGrey;
    	padding: 10px 16px;
    	.rounded(5px);

		&.hide {
			display: none;
		}

	}

	.opening-text {

		padding: 0;
    	margin: 0 0 15px;

	}

	.trial-text {

		background-color: @formDefaultColour;
		color: #fff;
		font-weight: normal;
	    padding: 6px 20px;
	    font-size: 14px;
	    margin-bottom: 10px;

	}

	.form {

		padding-bottom: 20px;;

		.v-select {

			margin-bottom: 10px;

		}

	}

	.modal-inner {

		max-width:450px;

		&.iframe {

			max-width:650px;

			.modal-inner-scroll {

				height: 100%;

				form {

					height: 100%;

				}

			}

		}

		&:before {

			display: none;

		}

		.modal-title {

			&.has-trial-text {

				margin-bottom: 0;

			}

			.text-wrap {

				display: block;
				white-space: nowrap;
				overflow: hidden;

				&:hover {

					white-space: normal;
					overflow: visible;

				}

			}

		}

	}
	.modal-inner-scroll {

		min-height: 66px;
   	 	padding-bottom: 0;

	}

	.address-input-wrap {

		margin-bottom: 10px;

	}

	.coupon {

		position: relative;
		margin: 15px 0;
		.vertical-align-parent;

		p {

			.opacity(0.8);
			font-size: 12px;
			cursor: pointer;
			padding: 0;
    		margin: 0;
    		display: inline-block;

    		&:hover {
    			color: @formDefaultColour;
    		}

		}

		[type=text] {

			padding:0 80px 0 0;
			font-size: 16px;
			border: none !important;
			background-color: #fff;

		}

		[type=button] {

			padding:0;
			font-size: 16px;
			display: block;
			border:none;
			background-color: @formDefaultColour;
			color: #fff;
			font-size: 12px;
			width: 60px;
			height: 26px;
			position: absolute;
		    top: 0;
		    right: 8px;
			outline: none;
		    cursor: pointer;
		    border:2px solid @formDefaultColour;
		    .rounded(5px);
		    .vertical-align;

		    &:hover {

				color: @formDefaultColour;
				background-color: #fff;

			}

		}

	}

	.pay-wrap {

		padding:10px 120px 0 0;
		position:relative;
		min-height: 46px;

		.message {

			padding: 10px 0 0;
		    text-align: left;
		    margin: 0;
		    color: @formDefaultColour;
		    line-height: 1.2em;

		}

		.pay-btn {

			background-color: @formDefaultColour;
			border:2px solid @formDefaultColour;
			color: #fff;
			padding: 0 8px;
		    line-height: 2em;
		    width: auto;
		    display: block;
			.rounded(0);
			position: absolute;
			right: 0;
			top: 10px;
			margin:0;
			outline: none;
			box-sizing: border-box;
			min-width: 100px;

			&:not(.disabled) {

				&:hover {

					color: @formDefaultColour;
					background-color: #fff;

				}

			}

			&.disabled {

				background-color: @darkContrast;
				border:2px solid @darkContrast;
				cursor: not-allowed;
				.opacity(0.5);

			}

		}

	}

}
</style>